import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import DEAItemsTable from './DEAItemsTable';


const DEAItemsAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM Do, YYYY')}
    icon={<BarnyardIcon icon={['fa', 'prescription-bottle-alt']} className='DiscussCard__replyIcon dea' />}
    title={(
      <div>
        <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
          {alert.buyer.name}
        </Link>
        {' '} placed an order containing a quantity of {' '}
        <strong className='u-colorRed'>
          {alert.value.quantity}
        </strong>
        {' '} controlled substances SKUs
      </div>
    )}
    content={(
      <DEAItemsTable
        includeExport={true}
        items={alert.value.items}
      />
    )}
    {...other}
  />
);

DEAItemsAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default DEAItemsAlert;
